import commoncss from "./../../css/common.module.css";
import bookclosuretaskscss from "./../../css/bookclosuretasks.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "./../../elements/Modal";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as ExcelUpload } from "../../assets/icons/tbExcelUpload.svg";
import { ReactComponent as PullERP } from "../../assets/icons/tbPullERP.svg";
import { ReactComponent as InfoPrimary } from "../../assets/icons/infoPrimary.svg";
import PullTBfromERPModal from "./PullTBfromERPModal";

const AddTBModal = ({
  handleClose,
  setUploadTBModal,
  setAddTBModal,
  setPullTBfromERPModal,
  isUpdateModal=false
}) => {


  return (
    <Modal
      title="Add Trial Balance"
      bodycss={commoncss.unsetPadding}
      width="fit-content"
      headerActions={
        <CloseIcon
          onClick={() => {
            handleClose();
            setUploadTBModal(false);
            setAddTBModal(false);
            setPullTBfromERPModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
    >
      <div class={`${commoncss.pdlr15} ${bookclosuretaskscss.taskContainer}`}>
        <div class={`${commoncss.pdlr15}  ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerLeft}`}>
          <div
            style={{ cursor:"pointer" }}
            onClick={() => {
              setUploadTBModal(true);
            }}
          >
            <ExcelUpload />
          </div>
        </div>
        <div class={`${commoncss.pdlr15} ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerRight}`}>
          <div
            style={{ cursor:"pointer" }}
            onClick={() => {
              setPullTBfromERPModal(true);
            }}
          >
            <PullERP />
          </div>
        </div>
      </div>
      {isUpdateModal && (
        <div style={{ padding: "0px 30px 10px"}}>
          <span class={`${bookclosurecss.trailBalanceLabel}`}><InfoPrimary /> The added trial balance will get appended with the existing trial balance</span>
        </div>
      )}
    </Modal>
  );
};

export default AddTBModal;
